export default "__VITE_ASSET__BDIlCKhW__"